<div class="ed-hero container">
  <div class="ed-head grid">
    <div class="cell l8 ed-headline-col">
      <h1>
        <span class="ed-host" fitText>{{ context.config.display_name }}</span>
        <span class="ed-desc"><strong i18n>steht zum Verkauf</strong></span>
      </h1>
    </div>
    <div class="cell l4 ed-trust-badge">
      <a class="ed-sold-via e--link-plain" [href]="context.links.promo_index|userToken" target="_blank">
        <app-icon>verified</app-icon>
        <div class="ed-content">
          <ng-container i18n>Sicherer Kauf mit</ng-container>

          <svg xmlns="http://www.w3.org/2000/svg" width="149.565" height="13.908" viewBox="0 0 149.565 13.908">
            <path class="ed-surface"
                  d="M1194.72,211.317v1.236h-9.56V199.034h9.271v1.236h-7.842v4.807h5.424v1.215h-5.424v5.025Zm3.36-12.283h1.429v12.283h7.571v1.236h-9Zm11.376,0h1.429v13.518h-1.429Zm8.459,1.236h-4.751v-1.236H1224.1v1.236h-4.753v12.283h-1.429Zm18.02,11.047v1.236h-9.56V199.034h9.271v1.236H1227.8v4.807h5.424v1.215H1227.8v5.025Zm17.959-5.524a6.923,6.923,0,0,1,7.281-6.953c4.191,0,7.281,2.936,7.281,6.953s-3.089,6.952-7.28,6.952a6.923,6.923,0,0,1-7.281-6.953Zm12.033,0a4.751,4.751,0,1,0-4.75,4.75,4.608,4.608,0,0,0,4.75-4.75Zm16.843,6.76-.019-8.962-4.442,7.416h-1.12l-4.442-7.3v8.844h-2.395V199.034h2.067l5.37,8.96,5.272-8.96h2.067l.019,13.52Zm20.492-13.519h2.513v13.518h-2.513Zm18.175,0v13.518h-2.067l-7.455-9.155v9.155h-2.492V199.034h2.067l7.455,9.155v-9.155Zm2.491,12.091.869-1.951a7.49,7.49,0,0,0,4.462,1.489c2.1,0,2.994-.753,2.994-1.758,0-2.916-8.035-1-8.035-6.026,0-2.183,1.738-4.037,5.447-4.037a8.548,8.548,0,0,1,4.5,1.2l-.791,1.951a7.511,7.511,0,0,0-3.727-1.062c-2.086,0-2.936.811-2.936,1.835,0,2.878,8.015,1,8.015,5.968,0,2.163-1.757,4.017-5.466,4.017a8.734,8.734,0,0,1-5.332-1.626Zm-28.487-12.091h-2.472l-6.084,13.518h2.588l.465-1.095h-.006l.2-.449.675-1.586.848-1.967,2.53-5.909,1.993,4.62h.01l.47,1.1.078.182h0l.841,1.992,1.342,3.107h2.627Zm-50.622,0h-5.909v10.138h2.512v-8.016h3.284c3.013,0,4.964,1.835,4.964,4.635s-1.951,4.636-4.964,4.636h-2.041v2.124h2.155c4.384,0,7.378-2.7,7.378-6.76s-2.994-6.758-7.378-6.758Z"
                  transform="translate(-1185.16 -198.84)" fill="#101010"/>
          </svg>
        </div>
        <div class="ed-logo-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="925" height="687" viewBox="0 0 925 687">
            <path class="ed-surface"
                  d="M3.39,0V687h925V0ZM158.08,309.43H332.34v68.08H158.08Zm276.39,238.3H158.08V479.64H434.47Zm136.17,0V479.64c75.45,0,136.83-61.47,136.83-136.92S646.09,207.3,570.64,207.3H502.56V411.56H434.47V207.3H158.25V139.21H570.64c112.25,0,203.58,91.25,203.58,203.51S682.89,547.73,570.64,547.73Z"
                  transform="translate(-3.39)"/>
          </svg>
        </div>
      </a>

      @if (context.offer.reserved) {
        <span edButton class="ed-buy-now ed--reserved">
              <span class="ed-reserved-label">Reserviert</span>
              <app-tooltip i18n>
              Diese Domain ist reserviert, weil sie verkauft wurde und derzeit übertragen wird. Sollte die Übertragung fehlschlagen, könnte die Domain erneut gekauft werden.
            </app-tooltip>
            </span>
      } @else {
        <a
          [edButton]="{ width: 'content' }"
          [href]="context.links.checkout"
          class="ed-buy-now"
          i18n
        >
          Jetzt kaufen
        </a>
      }
    </div>
  </div>

  <div class="ed-hero-content grid">
    <div class="cell l8 ed-image-col">
      <div class="ed-image">
        @if (context.config.template_data.image) {
          <div
            class="ed-inner ed--image"
            [ngStyle]="{'background-image': 'url(' + context.config.template_data.image + ')'}"
          ></div>
        } @else {
          <div class="ed-inner ed--text">
            <div fitText>{{ context.config.display_name }}</div>
            <span class="ed-desc">steht zum Verkauf</span>
          </div>
        }
        <div class="ed-ratio"></div>
      </div>
    </div>
    <div class="cell l4 ed-purchase-col">
      <h2 i18n>Domain jetzt kaufen!</h2>
      <p class="ed-description" i18n>
        Kaufen Sie die Adresse <strong>{{ context.config.display_name }}</strong> für nur
        <app-price [amount]="context.config.price"/>
        ohne USt. zum Festpreis. Jetzt als Sofortkauf mit dem Treuhandservice der ELITEDOMAINS GmbH.
      </p>
      <ul>
        <li>
          <app-icon>check</app-icon>
          <span i18n>Gratis</span>&nbsp;
          <ng-container i18n>Domainübertragung</ng-container>
        </li>
        <li>
          <app-icon>check</app-icon>
          <span i18n>Gratis</span>&nbsp;
          <ng-container i18n>Treuhandservice</ng-container>
        </li>
        <li>
          <app-icon>check</app-icon>
          <span i18n>Gratis</span>&nbsp;
          <ng-container i18n>Transferhilfe</ng-container>
        </li>
        <li>
          <app-icon>check</app-icon>
          <ng-container i18n>Sichere Zahlung</ng-container>
        </li>
      </ul>

      @if (context.config.price) {
        <div class="ed-price">
          <div class="ed-price-label" i18n>Preis</div>
          <div class="ed-price-value">
            <app-price [amount]="context.config.price"/>
            <div class="ed-price-tax" i18n>ohne MwSt.</div>
          </div>
          <div class="ed-price-tax-info" i18n (click)="openPopup()">
            Übersicht zur geschätzten Umsatzsteuer
          </div>
        </div>
      }

      @if (context.offer.reserved) {
        <span edButton class="ed-buy-now ed--reserved">
              <span class="ed-reserved-label" i18n>Reserviert</span>
              <app-tooltip i18n>
              Diese Domain ist reserviert, weil sie verkauft wurde und derzeit übertragen wird. Sollte die Übertragung fehlschlagen, könnte die Domain erneut gekauft werden.
            </app-tooltip>
            </span>
      } @else {
        <app-paynow-buy-buttons [context]="context"/>
      }

      <app-payment-methods/>

      @if (!context.offer.external) {
        <a href="https://www.denic.de/ueber-uns/unsere-mitglieder/mitgliederliste/mitglied?member=424" target="_blank"
           class="ed-denic-reference e--link-plain">
          <svg
            x="0px"
            y="0px"
            width="434.51401"
            height="221.103"
            viewBox="0 0 434.514 221.10299"
          >
            <g
              transform="translate(-203.624,-187.089)"
            >
              <path
                style="fill:#007a9d"
                d="m 530.869,340.646 h 20.633 V 262.175 H 530.869 Z M 314.175,187.089 c -61.058,0 -110.551,49.51 -110.551,110.556 0,61.052 49.493,110.547 110.551,110.547 61.05,0 110.552,-49.495 110.552,-110.546 0,-61.047 -49.502,-110.557 -110.552,-110.557 z m 174.188,73.136 c -12.672,0 -22.42,6.175 -27.455,12.023 v -10.072 h -20.633 v 78.471 h 20.633 v -52.965 c 3.574,-4.55 9.746,-9.098 17.869,-9.098 8.775,0 14.461,3.738 14.461,14.622 v 47.44 h 20.795 v -55.401 c 0,-15.272 -8.285,-25.02 -25.67,-25.02 z M 541.1,225.869 c -6.959,0 -12.725,5.601 -12.725,12.727 0,7.127 5.766,12.898 12.725,12.898 7.127,-0.001 12.896,-5.771 12.896,-12.898 0,-7.127 -5.769,-12.727 -12.896,-12.727 z m 66.982,98.367 c -12.512,0 -21.283,-9.26 -21.283,-22.906 0,-13.648 8.771,-22.746 21.283,-22.746 7.146,0 12.834,2.924 16.57,8.447 l 13.486,-12.671 c -5.201,-7.149 -14.947,-14.136 -31.031,-14.136 -24.047,0 -41.592,17.061 -41.592,41.105 0,24.207 17.545,41.265 41.592,41.265 16.084,0 25.83,-7.147 31.031,-14.294 l -13.486,-12.674 c -3.736,5.362 -9.423,8.61 -16.57,8.61 z"
                class="ed-surface"
              />
              <path
                style="fill:#ffffff"
                d="m 286.614,272.048 c -6.174,-8.231 -15.055,-12.293 -24.533,-12.293 -20.037,0 -34.768,15.65 -34.768,41.104 0,26.212 15,41.267 34.768,41.267 9.803,0 18.412,-4.44 24.533,-12.239 v 10.29 h 19.549 V 228.854 h -19.549 z m 0,43.325 c -3.521,5.415 -11.316,9.477 -18.52,9.477 -12.457,0 -20.742,-9.803 -20.742,-23.991 0,-14.026 8.285,-23.827 20.742,-23.827 7.203,0 14.998,4.061 18.52,9.477 z m 115.11,-12.727 c 0,-25.236 -15.488,-42.891 -39.047,-42.891 -23.559,0 -40.346,18.358 -40.346,41.104 0,25.074 17.818,41.267 41.646,41.267 12.238,0 24.316,-3.845 32.168,-11.102 l -8.773,-12.836 c -5.254,5.146 -14.299,8.016 -21.338,8.016 -13.809,0 -21.932,-8.609 -23.34,-18.899 h 59.029 v -4.659 z m -59.192,-8.935 c 0.758,-8.341 6.715,-18.035 20.09,-18.035 14.242,0 19.822,9.965 20.418,18.035 z"
                class="ed-surface ed--white"
              />
            </g>
          </svg>
          <span class="ed-label" i18n>Abwicklung durch DENIC Mitglied</span>
        </a>
      }
    </div>
    <div class="cell l8 ed-usp-col">
      @if (context.config.template_data['individual-content--text']) {
        <app-content-block
          [content]="{
          headline: context.config.template_data['individual-content--headline'],
          text: context.config.template_data['individual-content--text'],
        }"
        />
      }

      <div class="ed-usps">
        <h2 i18n>Sicherer Domain-Kauf mit Treuhand-Service</h2>

        <div class="ed-list">
          @for (usp of usps; track usp.head) {
            <div class="ed-usp">
              <div class="ed-usp-head">
                <app-icon>{{ usp.icon }}</app-icon>
                <h3>{{ usp.head }}</h3>
              </div>
              <p [innerHTML]="usp.body"></p>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>

<div class="ed-faqs">
  <div class="container">
    <div class="ed-head">
      <h2 i18n>Häufige Fragen und Antworten zum Domainkauf</h2>
      <p class="ed-subhead" i18n>Diese Fragen werden häufig von Domain-Käufern gestellt.</p>
    </div>

    <app-accordion [entries]="PaynowFrequentQuestions"/>

    <div class="ed-actions">
      <a
        href="https://elitedomains.de/faq/domain-kauf-infos"
        [edButton]="{ theme: 'secondary', width: 'content' }"
        target="_blank"
        i18n
      >Weitere Antworten</a>
    </div>
  </div>
</div>

<app-paynow-footer [context]="context"/>
